module.exports = __webpack_public_path__ + "5834-shadow.f8554fee7439ddabee725656ba86b12f.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/5834-shadow.png
// module id = 631
// module chunks = 0